import React from "react";
import { Upload } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ImageUploadButtonProps {
  onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

export const ImageUploadButton = ({ onUpload, disabled = false }: ImageUploadButtonProps) => {
  const { t } = useTranslation();
  
  return (
    <label className={`${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
      <div className={`flex flex-col items-center justify-center w-full aspect-square border-2 border-dashed rounded-lg
        ${disabled 
          ? 'border-gray-300 bg-gray-50' 
          : 'border-gebeya-pink/20 hover:border-gebeya-pink/40 hover:bg-pink-50/30 transition-colors'
        }`}
      >
        <Upload className={`w-8 h-8 ${disabled ? 'text-gray-400' : 'text-gebeya-pink'}`} />
        <span className="mt-2 text-sm text-gray-500">{t('services.uploadImages')}</span>
        <span className="text-xs text-gray-400">{t('services.maximumSize')}</span>
      </div>
      <input
        type="file"
        className="hidden"
        accept="image/*"
        multiple
        onChange={onUpload}
        disabled={disabled}
      />
    </label>
  );
};
